import { render, staticRenderFns } from "./shipmentDetailPage.vue?vue&type=template&id=06a85b36&scoped=true&"
import script from "./shipmentDetailPage.vue?vue&type=script&lang=js&"
export * from "./shipmentDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./shipmentDetailPage.vue?vue&type=style&index=0&id=06a85b36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a85b36",
  null
  
)

export default component.exports